import {
  defineProductDimensions,
  frMrpaxePricingVersionDimension,
  frMrpaxeSelectedDimension,
} from '@orus.eu/dimensions'

import { frMrpaxeProductVersionDimension } from './fr-mrpaxe-dimensions.ts'
import { frMrpaxeQuoteDimension } from './fr-mrpaxe-quote-dimension.ts'

export * from './fr-mrpaxe-dimensions.ts'
export * from './fr-mrpaxe-policy-item-dimensions.ts'
export * from './fr-mrpaxe-quote-dimension.ts'
export * from './fr-mrpaxe-subscription-ui.ts'
export * from './fr-mrpaxe-ui-elements.ts'

export const frMrpaxeDimensionsModule = defineProductDimensions({
  product: 'fr-mrpaxe',
  family: 'mrp',
  selectionDimension: frMrpaxeSelectedDimension,
  productVersionDimension: frMrpaxeProductVersionDimension,
  pricingVersionDimension: frMrpaxePricingVersionDimension,
  quoteV3Dimension: frMrpaxeQuoteDimension,
})
